import './App.css';
import {  BrowserRouter as Router } from 'react-router-dom';
import { CommonRoutes } from './routes/CommonRoutes';
// import ListingTable from './components/FileUpload/ListingTable';

function App() {
  return (
    <Router>
      <CommonRoutes/>
    </Router>
  );
}

export default App;
